<template>
  <BasePanel
    class="track-complaint-status__container"
    title="Track Complaint Status"
  >
    <div class="d-flex">
      <div class="flex-none" style="font-weight: 600">Complaint:</div>

      <p
        v-if="complaint"
        :style="{ color: complaint.status && complaint.status.color }"
        class="ml-1"
      >
        {{ complaint.status && complaint.status.name }}
      </p>

      <p v-else-if="complaint === null" style="color: var(--danger)">
        Can not find complaint
      </p>
    </div>

    <div class="d-flex mt-2">
      <v-text-field
        v-model="complaintIdSearchText"
        type="number"
        solo
        single-line
        dense
        hide-details
        :disabled="searchComplaintLoading"
        placeholder="Enter Complaint ID "
        @keyup.enter="searchComplaint"
        style="font-size: 1em"
      />

      <v-btn
        class="flex-none"
        color="primary"
        :disabled="!complaintIdSearchText"
        :loading="searchComplaintLoading"
        @click="searchComplaint"
      >
        Submit
      </v-btn>
    </div>
  </BasePanel>
</template>
<script>
import BasePanel from "@/components/BasePanel";
import api from "@/api";

export default {
  components: {
    BasePanel
  },

  data() {
    return {
      complaintIdSearchText: null,

      complaint: undefined,

      searchComplaintLoading: false
    };
  },

  methods: {
    async searchComplaint() {
      try {
        this.complaint = undefined;
        this.searchComplaintLoading = true;

        const res = await api.searchComplaint(this.complaintIdSearchText);

        this.complaint = res.data.data ? res.data.data : null;
      } catch (error) {
        this.$notify({
          type: "error",
          message: error.message
        });
      } finally {
        this.searchComplaintLoading = false;
      }
    }
  }
};
</script>
<style scoped>
.v-input__control {
  background: #999;
  color: white;
  border-radius: 0.3125em;
  padding: 0.625em;
}

.header {
  background-color: var(--primary);
  padding: 1em !important;
}

.track-complaint-status__container {
  color: var(--text-color);
}
</style>
